import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../assets/animation/empty.json';

export default class Empty extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isStopped: false, isPaused: false };
    }

    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
            },
        };

        return (
            <Lottie
                options={defaultOptions}
                height={239}
                width={239}
                isStopped={this.state.isStopped}
                isPaused={this.state.isPaused}
            />
        );
    }
}
